<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="p-2">
        <h1 class="text-title-underline">{{ t('seminar.title') }}</h1>
        <template v-if="toArray(seminars).length">
          <div
            v-for="item in pagedList" :key="item.id"
            class="card-outlined p-4 mb-2"
          >
            <div class="text-subtitle-underline">{{ item.title }}</div>
            <div class="v-html whitespace-pre-wrap" v-html="item.summary" />
            <div class="flex items-center justify-end mt-4">
              <template v-if="item.open_at">
                <template v-if="isOpen(item.open_at) && !isClosed(item.closed_at)">
                  <template v-if="item.seminar_user">
                    <router-link
                      :to="`/seminar/${item.id}`"
                      class="text-link"
                    >
                      <button class="bg-yellow-500 hover:bg-yellow-600 text-white button-pill">
                        {{ t('seminar.button.confirm') }}
                      </button>
                    </router-link>
                  </template>
                  <template v-else>
                    <router-link
                      :to="`/seminar/${item.id}`"
                      class="text-link"
                    >
                      <button class="bg-blue-500 hover:bg-blue-600 text-white button-pill">
                        {{ t('seminar.button.apply') }}
                      </button>
                    </router-link>
                  </template>
                </template>
                <template v-else>
                  <template v-if="isClosed(item.closed_at)">
                    <button class="bg-gray-500 text-white button-pill">
                      {{ t('seminar.button.closed') }}
                    </button>
                  </template>
                  <template v-else-if="!isOpen(item.open_at)">
                    <button class="bg-gray-500 text-white button-pill">
                      {{ t('seminar.button.before_open') }}
                    </button>
                  </template>
                </template>
              </template>
            </div>
          </div>
          <div class="flex items-center justify-center mt-10">
            <base-pagination v-model:pagedList="pagedList" :originalList="seminars" :pageSize="pageSize" />
          </div>
        </template>
        <template v-else>
          セミナー情報はありませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useStore } from '@/store/index'
import { useI18n } from 'vue-i18n'
import LayoutsAuth from '@/layouts/Auth.vue'
import { toArray } from '@/utils/array'
import BasePagination from '@/components/BasePagination.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BasePagination, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const seminars = computed(() => store.state.seminar.seminars)
    const pageSize = ref(5)
    const pagedList = ref([])

    onMounted(() => {
      store.dispatch('seminar/fetchSeminars')
    })

    const isOpen = (openAt: string) => (new Date(openAt) < new Date())
    const isClosed = (closedAt: string) => (new Date(closedAt) < new Date())

    return {
      t,
      seminars,
      isOpen,
      isClosed,
      toArray,
      pageSize,
      pagedList
    }
  },
})
</script>
